module.exports = __webpack_public_path__ + "static/media/Arts.dc47f10b.jpg";